<template>
  <div>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      viewBox="82.82978723404256 61.9078014184397 505.41843971631215 279.88652482269515"
      width="701.42"
      height="475.89"
    >
      <defs>
        <path
          d="M585.25 338.79L568.23 258.65L533.48 303.33L476.74 296.24L429.93 277.8L397.3 141.63L360.43 262.91L305.11 309.72L268.94 268.58L234.18 329.57L192.34 255.82L156.17 329.57L111.49 250.14L83.83 338.79L585.25 338.79Z"
          id="b6RQ5J4bJ"
        ></path>
        <path
          d="M568.94 337.38L534.18 162.2L505.82 279.22L476.03 238.79L438.44 321.77L395.18 273.55L351.91 321.77L320.71 142.34L315.74 313.97L291.63 289.86L274.61 311.13L258.3 292.7L238.44 311.13L219.29 247.3L183.83 316.1L153.33 62.91L113.62 306.17L101.56 173.55L83.83 337.38L568.94 337.38Z"
          id="b1RypI0Jnh"
        ></path>
      </defs>
      <animate
        attributeName="opacity"
        dur="1s"
        values="0;1;0"
        repeatCount="indefinite"
        begin="0.1"
      />
      <g>
        <g>
          <use xlink:href="#b6RQ5J4bJ" opacity="1" fill="#f0f0f0" fill-opacity="1"></use>
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.2"
          />
          <g>
            <use
              xlink:href="#b6RQ5J4bJ"
              opacity="1"
              fill-opacity="0"
              stroke="#f3f3f3"
              stroke-width="1"
              stroke-opacity="1"
            ></use>
          </g>
        </g>

        <g>
          <use xlink:href="#b1RypI0Jnh" opacity="1" fill="#f3f3f3" fill-opacity="1"></use>
          <g>
            <use
              xlink:href="#b1RypI0Jnh"
              opacity="1"
              fill-opacity="0"
              stroke="#f3f3f3"
              stroke-width="1"
              stroke-opacity="1"
            ></use>
            <animate
              attributeName="opacity"
              dur="1s"
              values="0;1;0"
              repeatCount="indefinite"
              begin="0.3"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'EngagementGraphLoader',
};
</script>



// WEBPACK FOOTER //
// EngagementGraphLoader.vue?0afb8031